import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { ExpediteShippingState } from "@TKCCP/Store/Data/ExpediteShipping/ExpediteShippingState";
import { ExpediteShippingModel } from "@TKCCP/Types/ApiModels";
import { Draft } from "immer";

const initialState: ExpediteShippingState = {
    byId: {},
    isLoading: {},
    dataViews: {},
};

const reducer = {
    "Data/ExpediteShipping/BeginLoadExpediteShipping": (
        draft: Draft<ExpediteShippingState>,
        action: { cartId: string },
    ) => {
        draft.isLoading[action.cartId] = true;
    },

    "Data/ExpediteShipping/CompleteLoadExpediteShipping": (
        draft: Draft<ExpediteShippingState>,
        action: { cartId: string; model: ExpediteShippingModel | undefined },
    ) => {
        delete draft.isLoading[action.cartId];
        if (action.model) {
            draft.byId[action.cartId] = action.model;
        }
    },

    "Data/ExpediteShipping/Reset": () => {
        return initialState;
    },
};

const expediteShippingReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).expediteShipping = expediteShippingReducer;
